import { createFileRoute } from '@tanstack/react-router'
import AppDetailsPage from '@/components/pages/AppDetailsPage/AppDetailsPage'
import { z } from 'zod'

const appDetailsSearchSchema = z.object({
  page: z.number().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  status: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/apps/$name/')({
  validateSearch: (search) => appDetailsSearchSchema.parse(search),
  component: AppDetailRoute,
})

function AppDetailRoute() {
  return <AppDetailsPage />
}
